import axios from 'axios';
import { dispatchSystemError } from '@/helpers';

export const version = 'v1';
export const version2 = 'v2';
export const baseDomain = (document.querySelector('base') || {}).href;
export const apiDomain = `${baseDomain}api/${version}`;
export const apiDomainV2 = `${baseDomain}api/${version2}`;
export const apiDomainEmploy = `${baseDomain}api/${version}/employ`;

// CERTIFICATES
export const certificateUrl = `${apiDomain}/certificates`;
export const getPreloadUrl = `${apiDomain}/certificates/preload`;
export const prepareCertificateUrl = `${apiDomain}/certificates/prepare`;
export const certViewUrl = `${apiDomain}/certificates/view`;
export const sendCertEmailUrl = `${apiDomain}/certificates/send`;
export const deleteCertificateUrl = `${apiDomain}/certificates/force`;
export const restoreCertificateUrl = `${apiDomain}/certificates/restore`;
export const archiveUrl = `${apiDomain}/certificates/archive`;
export const id06OrderUrl = `${apiDomain}/id06/order`;
export const exportSsgUrl = `${apiDomain}/integrations/ssg/export`;
export const integrationSsgSkillTypesUrl = `${apiDomain}/integrations/ssg/skilltypes`;

// COMPANY
export const companyUrl = `${apiDomain}/companies/departments`;
export const companyEmployUrl = `${apiDomain}/companies/employdepartments`;
export const companyEmployInviteUrl = `${apiDomain}/companies/employinvite`;

// DEPARTMENTS
export const depUrl = `${apiDomain}/departments`;
export const accessDepartmentUrl = `${apiDomain}/departments/access/request`;
export const depUsersUrl = `${apiDomain}/departments/users`;
export const getCompetenciesUrl = `${apiDomain}/departments/competences`;
export const createCompetenciesUrl = `${apiDomain}/departments/competences`;
export const depAccessUrl = `${apiDomain}/departments/access`;
export const depInviteUrl = `${apiDomain}/departments/access/invite`;
export const depAcceptUrl = `${apiDomain}/departments/access/accept`;
export const compEditUrl = `${apiDomain}/departments/competences/edit`;
export const compSetUrl = `${apiDomain}/departments/competences/edit`;
export const compDeselectUrl = `${apiDomain}/departments/competences/edit?action=deselect`;
export const compUpdateUrl = `${apiDomain}/departments/competences`;
export const onboardingUrl = `${apiDomain}/departments/onboarding`;
export const completeOnboardingUrl = `${onboardingUrl}/complete`;
export const statisticsUrl = `${apiDomain}/departments/statistics`;
export const downgradeUrl = `${apiDomain}/departments/plans/downgrade`;
export const upgradeUrl = `${apiDomain}/departments/plans/upgrade`;
export const changePlanUrl = `${apiDomain}/departments/plans/change`;
export const getInvoiceUrl = `${apiDomain}/departments/invoices/pdf`;
export const currentBillingCycle = `${apiDomain}/departments/billing/cycle`;

// Plans
export const plansUrl = `${apiDomain}/plans`;
export const getAddonsUrl = `${apiDomain}/addons`;
export const ActivateAddonUrl = `${apiDomain}/departments/addons`;

// CLIENTS
export const clientUrl = `${apiDomain}/departments/clients`;
export const clientInviteUrl = `${apiDomain}/departments/clients/invite`;

// EMPLOYEES
export const employUrl = `${apiDomain}/employ`;
export const employeeUrl = `${employUrl}/employees`;

// USERS
export const bankIdUrl = `${apiDomain}/bankid/auth`;
export const bankIdCollectUrl = `${apiDomain}/bankid/collect`;
export const bankIdCancelUrl = `${apiDomain}/bankid/cancel`;
export const registerUrl = `${apiDomain}/auth/register`;
export const logoutUrl = `${apiDomain}/auth/logout`;
export const authBaseUrl = `${apiDomain}/auth`;
export const meUrl = `${apiDomain}/users/me`;
export const myCertificatesUrl = `${apiDomain}/users/me/certificates`;
export const userUrl = `${apiDomain}/users`;
export const profileUrl = `${apiDomain}/users/profile`;
export const mergeUsersUrl = `${apiDomain}/users/merge-users`;
export const ID06ConsentUrl = `${apiDomain}/id06/consent`;

// SUPER ADMIN
export const SuperAdminBaseUrl = `${apiDomain}/superadmin`;
export const SuperAdminBaseUrlV2 = `${apiDomainV2}/superadmin`;

export const askApi = axios.create({
    baseURL: apiDomain,
});

export function getRequest(url, payload = {}, signal = null) {
    return new Promise((resolve, reject) => {
        askApi
            .get(url, {
                params: payload,
                signal: signal, // Support for AbortController signal
            })
            .then((response) => {
                if (response?.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response?.data || null);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function postRequest(url, payload = {}, options = {}) {
    return new Promise((resolve, reject) => {
        askApi
            .post(url, payload, options)
            .then((response) => {
                if (response?.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateRequest(url, payload = {}, options = {}) {
    return new Promise((resolve, reject) => {
        askApi
            .put(url, payload, options)
            .then((response) => {
                if (response?.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function patchRequest(url, payload = {}, options = {}) {
    return new Promise((resolve, reject) => {
        askApi
            .patch(url, payload, options)
            .then((response) => {
                if (response?.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function deleteRequest(url, payload = null) {
    return new Promise((resolve, reject) => {
        askApi
            .delete(url, payload)
            .then((response) => {
                if (response?.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * Request interceptor for API calls
 */
askApi.interceptors.request.use(
    async (config) => {
        const user = JSON.parse(localStorage.system_cache || '{}');

        // const query_params = new Proxy(new URLSearchParams(window.location.search), {
        //     get: (searchParams, prop) => searchParams.get(prop),
        // });

        config.headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...config.headers,
        };

        // if (user.department_id || query_params.fd) {
        if (user.department_id) {
            config.headers['Cervd-Department-Id'] = user.department_id;
        }

        // if (user.current_profile_id || query_params.fp) {
        if (user.current_profile_id) {
            config.headers['Cervd-Profile-Id'] = user.current_profile_id;
        }

        if (user.token) {
            config.headers['Authorization'] = `Bearer ${user.token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Response interceptor for API calls
 */
askApi.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error && error.response && error.response.status === 401) {
            dispatchSystemError('Din session löpte ut, vänligen logga in på nytt.');
            console.debug('Unauthorized request, redirecting to login page');
            localStorage.removeItem('system_cache');

            setTimeout(() => {
                location.href = '/';
            }, 1000);
        } else if (error && error.response && error.response.status === 419) {
            dispatchSystemError('Din session löpte ut, vänligen logga in på nytt.');
            console.debug('CSRF token mismatch, attempting to refresh by reloading');

            setTimeout(() => {
                document.location.reload();
            }, 1000);
        } else {
            return Promise.reject(error);
        }
    }
);
